import {SigninForm} from "../molecules/SigninForm";
import React, {useEffect, useState} from "react";
import axios from "axios";
import {getAxiosBaseUrl, getBaseUrlNodeServer} from "../../config";
import {Button} from "@mui/material";
import DeleteOutlined from "@mui/icons-material/DeleteOutlined";
import {toast} from "react-toastify";

export default function AIAdmin() {
	var signedin = sessionStorage.getItem("signedin");
	const [modelList, setmodelList] = useState([]);
	const [pdfNamesAndIds, setpdfNamesAndIds] = useState(null);
	const [currentPdfName, setcurrentPdfName] = useState('');
	const [currentPdfId, setcurrentPdfId] = useState('');
	const [skillText, setSkillText] = useState('');
	const [experienceText, setexperienceText] = useState('');
	const [educationText, seteducationText] = useState('');
	const [pdfText, setpdfText] = useState('');
	const [pdfUrl, setPdfUrl] = useState('');
	const [promptsData, setPromptsData] = useState([]);
	var verifiedemail = sessionStorage.getItem("verifiedemail");
	const removeRow = (prompt, index) => {
		if (index >= 0 && index < promptsData.length) {
			toast.info('Removed Row', {
				position: "top-right", autoClose: 2000
			});
			try {
				axios.defaults.baseURL = getAxiosBaseUrl()
				axios.post('deleteprompt', {
					'prompt': prompt, 'verifiedemail': verifiedemail
				}).then(response => {
					console.log(response.data);
				}).catch(err => console.log(err));
			} catch (error) {
				console.error('Error during fetch:', error.message);
			}
			
			// const newData = [...data];
			// newData.splice(index, 1);
			// setData(newData);
			
			window.location.reload();
		} else {
			toast.error('Invalid Row Index');
		}
	};
	
	function getAllPdfData() {
		axios.defaults.baseURL = getBaseUrlNodeServer();
		axios.get('/getAllPdfs').then(response => {
			setpdfNamesAndIds(response.data)
			if (response.data.length > 0) {
				loadPdfFile(response.data[0])
			}
		})
	}
	
	const textStyle = {
		fontSize: '16px',
		fontWeight: 'bold',
		backgroundImage: 'linear-gradient(90deg, rgb(155, 66, 255), rgb(246, 75, 255), rgb(235, 123, 163))',
		WebkitBackgroundClip: 'text', // Note the camelCase and the Webkit prefix
		color: 'transparent',
		backgroundClip: 'text',
		// display: 'flex',
	};
	
	function getAllPromptsData() {
		axios.defaults.baseURL = getAxiosBaseUrl();
		axios.post('/getAllPromptsData', {'verifiedemail': verifiedemail}).then(response => {
			// console.log(response.data);
			setPromptsData(response.data);
		})
	}
	
	function loadPdfFile(rec) {
		axios.defaults.baseURL = getBaseUrlNodeServer();
		axios.get('/getPdf/' + rec._id, {responseType: 'blob'}).then(response => {
			const pdfBlob = new Blob([response.data], {type: 'application/pdf'});
			const pdfUrl = URL.createObjectURL(pdfBlob);
			setPdfUrl(pdfUrl);
		})
		setcurrentPdfName(rec.filename)
		setcurrentPdfId(rec._id)
		
		axios.defaults.baseURL = getBaseUrlNodeServer();
		axios.get('/getPdfText/' + rec._id).then(response => {
			// document.getElementById('resumeText') ? document.getElementById('resumeText').value = response.data : null;
			setpdfText(response.data);
		});
		
		axios.defaults.baseURL = getBaseUrlNodeServer();
		axios.get('/getSkillText/' + rec._id).then(response => {
			// document.getElementById('resumeText') ? document.getElementById('resumeText').value = response.data : null;
			setSkillText(response.data);
		});
		
		axios.defaults.baseURL = getBaseUrlNodeServer();
		axios.get('/getExperienceText/' + rec._id).then(response => {
			// document.getElementById('resumeText') ? document.getElementById('resumeText').value = response.data : null;
			setexperienceText(response.data);
		});
		
		axios.defaults.baseURL = getBaseUrlNodeServer();
		axios.get('/getEducationText/' + rec._id).then(response => {
			seteducationText(response.data);
		});
	}
	
	useEffect(() => {
		async function getAccessToken() {
			try {
				axios.defaults.baseURL = getAxiosBaseUrl();
				const response = await axios.post('fetchModelsInformation', {
					'verifiedemail': sessionStorage.getItem("verifiedemail")
				})
				// console.log(response.data);
				setmodelList(JSON.parse(response.data));
			} catch (e) {
				console.error("Error fetching access token:", e);
			}
			// getModelList();
			// getAndSetJobData();
			// getGisData();
		}
		
		getAccessToken();
		getAllPdfData();
		getAllPromptsData();
	}, []);

	const skillChangeEvent = (e) => setSkillText(e.target.value);
    const experienceChangeEvent = (e) => setexperienceText(e.target.value);
    const educationChangeEvent = (e) => seteducationText(e.target.value);
    const saveTextChangeToDb = (e) => setpdfText(e.target.value);
	
	function addPromptToMongo(e) {
		console.log('I got a request to add the prompt')
		console.log('e', e)
		// addprompt
	}
	
	if (!signedin) {
		return <div style={{marginTop: "300px"}}>
			<SigninForm/>
		</div>
	} else {
		return (<div style={{
			marginTop: "10px", marginLeft: "0px", minHeight: "0px",
		}}>
			<div style={{fontSize: "20px", display: "flex"}}>AI Admin Page</div>
			<div style={{color: "blue"}}>
				<li key='1'>Select the Resume</li>
				<li key='2'>Select the Prompt Question</li>
				<li key='2'>Select the model</li>
				<li key='2'>See the previous results</li>
				<li key='2'>Run the new results</li>
			</div>
			<div style={{}}>Your Files:</div>
			<div style={{
				marginLeft: "10px",
				border: "1px solid lightgrey",
				marginTop: "10px",
				padding: "10px",
				borderRadius: "10px",
				maxHeight: "200px",
				overflowY: "scroll",
				marginRight: "20px"
			}}>
				{pdfNamesAndIds ? pdfNamesAndIds.map(rec => {
					return (<div style={{display: "flex"}}>
						<li className='pdfListItem' onClick={() => loadPdfFile(rec)}>
							{rec.filename}
						</li>
					</div>)
				}) : <li>Loading Names...</li>}
			</div>
			<div style={{marginTop: "10px"}}>
				<div style={{marginBottom: "20px", marginTop: "10px", display: "flex", alignItems: "center"}}>
				</div>
				<div>
					<p style={{height: "30px", textAlign: "center", marginLeft: "-20px"}}>Selected File Name:
						<span style={{fontWeight: "bold", marginLeft: "10px"}}>{currentPdfName ? currentPdfName : ''}</span>
					</p>
					{pdfUrl ? (<div style={{display: "flex"}}>
						<div style={{marginRight: "10px", marginTop: "-20px"}}>
							<div style={textStyle}>Skills</div>
							<textarea onChange={(e) => skillChangeEvent(e)} style={{
								border: "1px solid lightgrey",
								height: "160px", borderRadius: "5px", padding: "10px", minWidth: "300px"
							}}
							          placeholder='Add Skills Here' value={skillText}/>
							<div style={textStyle}>Experience</div>
							<textarea style={{
								marginLeft: "0px",
								border: "1px solid lightgrey",
								height: "240px",
								borderRadius: "5px",
								padding: "10px",
								minWidth: "300px"
							}}
							          onChange={(e) => experienceChangeEvent(e)}
							          value={experienceText}
							          placeholder='Add Experience Text Here'/>
							<div style={textStyle}>Education</div>
							<textarea style={{
								marginLeft: "0px",
								border: "1px solid lightgrey",
								height: "100px",
								borderRadius: "5px",
								padding: "10px",
								minWidth: "300px"
							}}
							          onChange={(e) => educationChangeEvent(e)}
							          value={educationText}
							          placeholder='Add Education Text Here'/>
						</div>
						<textarea id='resumeText' style={{
							border: "1px solid black", borderRadius: "10px", width: '30%', height: '60vh', padding: "20px", marginRight: "10px"
						}} onChange={(e) => saveTextChangeToDb(e)}
						          value={pdfText}
						/>
						<iframe src={pdfUrl} style={{
							width: '50%', height: '60vh', borderRadius: "10px", border: "1px solid lightgrey", padding: "20px", paddingTop: "0px"
						}} frameBorder="0"></iframe>
					</div>) : (
						<p>Loading PDF...</p>)}
				</div>
			</div>
			<div>
				<label>Add A Prompt:</label>
				<input style={{
					marginLeft: "10px", minWidth: "500px", border: "1px solid lightgrey", height: "40px", marginTop: "20px", padding: "10px"
				}}/>
				<Button variant='outlined' style={{marginLeft: "20px"}} onChange={(e) => addPromptToMongo(e)}>Add Prompt</Button>
			</div>
			<div style={{fontSize: "20px", display: "flex", marginTop: "20px", maxHeight: '500px', overflow: "scroll"}}>
				<table>
					<thead>
					<tr style={{
						minWidth: "50px", textAlign: "center", fontSize: "16px"
					}}>
						<th>Row Id</th>
						<th>Prompt</th>
						<th style={{paddingLeft: "30px", textAlign: "center"}}>Response</th>
						<th style={{paddingLeft: "30px", textAlign: "center"}}>Response Time (min.)</th>
					</tr>
					</thead>
					<tbody>
					{promptsData.map((prompt, index) => (<tr key={index} style={{
							background: '#ece8e894', border: '1px solid black', borderRadius: '30px'
						}}>
							<td style={{
								maxWidth: "800px",
								textAlign: "left",
								fontSize: "12px",
								border: "1px solid lightgrey",
								borderRadius: "10px",
								padding: "10px"
							}}>{index + 1}</td>
							<td style={{
								maxWidth: "800px",
								textAlign: "left",
								fontSize: "12px",
								border: "1px solid lightgrey",
								borderRadius: "10px",
								padding: "10px"
							}}>{prompt.promptQuestion}</td>
							<td style={{
								maxWidth: "800px",
								textAlign: "left",
								fontSize: "12px",
								border: "1px solid lightgrey",
								borderRadius: "10px",
								padding: "10px"
							}}>-
							</td>
							<td style={{paddingLeft: "10px"}}>
								<div className="tooltip" onClick={() => removeRow(prompt, index)} style={{
									justifyContent: 'center', cursor: 'pointer', borderRadius: '5px', display: "flex", border: "1px dotted grey",
									padding: "2px", backgroundColor: "rgb(238 207 175 / 86%)",
								}}>
									<div className="tooltiptext2">Delete Contact</div>
									<DeleteOutlined/>
								</div>
							</td>
						</tr>
					))}
					</tbody>
				</table>
			</div>
			
			<div style={{fontSize: "20px", display: "flex"}}>
				<table>
					<thead>
					<tr style={{
						minWidth: "50px", textAlign: "center", fontSize: "16px"
					}}>
						<th>Model Name</th>
						<th>Size (Bytes)</th>
						<th>Run Command</th>
					</tr>
					</thead>
					<tbody>
					{modelList.map((model, index) => (<tr key={index} style={{
						background: '#ece8e894', border: '1px solid black', borderRadius: '30px'
					}}>
						<td style={{
							minWidth: "50px",
							textAlign: "center",
							fontSize: "12px",
							border: "1px solid lightgrey",
							borderRadius: "10px",
							padding: "10px"
						}}>{model.name}</td>
						<td style={{
							minWidth: "50px",
							textAlign: "center",
							fontSize: "12px",
							border: "1px solid lightgrey",
							borderRadius: "10px",
							padding: "10px"
						}}>{(model.size / 1073741824).toFixed(2)} GB
						</td>
						<td style={{
							minWidth: "50px",
							textAlign: "left",
							fontSize: "12px",
							border: "1px solid lightgrey",
							borderRadius: "10px",
							padding: "10px"
						}}>
							n_gpu_layers matters ... that decides how much gpu ram is going to be used
							TENSOR_SPLIT matters ... helps divide the gpu ram requirement across multiple gpus
						</td>
					</tr>))}
					</tbody>
				</table>
			</div>
			<div style={{marginTop: "20px"}}>
				Load Model Command:
			</div>
			<div style={{marginLeft: "20px", background: "#ece8e894", padding: '10px'}}>
				export TENSOR_SPLIT="[60, 40]" <br/>
				python3 -m llama_cpp.server --host 0.0.0.0 --model /home/quantus/models/miqu-1-70b-Requant-b2131-iMat-c32_ch400-IQ1_S_v3.gguf --n_gpu_layers 81 --split_mode 2 --use_mlock True --n_ctx 3400 --n_threads 6 --use_mmap False
			</div>
			<div style={{marginLeft: "20px", background: "#ece8e894", padding: '10px'}}>
				export TENSOR_SPLIT="[50, 35]"<br/>
				python3 -m llama_cpp.server --host 0.0.0.0 --model /home/quantus/models/miqu-1-70b-Requant-b2035-iMat-c32_ch400-IQ2_XXS.gguf
				--n_gpu_layers 70 --split_mode 2 --use_mlock True --n_ctx 2048 --n_threads 6 --use_mmap False
			</div>
			<div style={{marginLeft: "20px", background: "#ece8e894", padding: '10px'}}>
				<p> 11Gb + 8GB GPU configuration</p>
				export TENSOR_SPLIT="[40, 28]"<br/>
				python3 -m llama_cpp.server --host 0.0.0.0 --model /home/quantus/models/miqu-1-70b-Requant-b2007-iMat-c32_ch400-IQ3_XXS.gguf
				--n_gpu_layers 45 --split_mode 2 --use_mlock True --n_ctx 3400 --n_threads 6 --use_mmap False
				
				<br/>
				python3 -m llama_cpp.server --host 0.0.0.0 --model /home/quantus/models/miqu-1-70b-Requant-b2007-iMat-c32_ch400-IQ3_XXS.gguf
				--n_gpu_layers 45 --split_mode 2 --use_mlock True --n_ctx 2048 --n_threads 6 --use_mmap False
				
				<p> 11Gb + 24GB GPU configuration</p>
				export TENSOR_SPLIT="[80, 20]"<br/>
				python3 -m llama_cpp.server --host 0.0.0.0 --model /home/quantus/models/miqu-1-70b-Requant-b2007-iMat-c32_ch400-IQ3_XXS.gguf --n_gpu_layers 81 --split_mode 2 --use_mlock True --n_ctx 3400 --n_threads 6 --use_mmap False
			</div>
		</div>)
	}
}